import { axios } from "../../helper/axios";
import { RequestConstant } from "./RequestConstant";

const RequestVehicleApi = {};

RequestVehicleApi.getRequestVehicleData = (data) => {

  

  const {payload:page}=data
 
    let queryParam = "";

  
    if ( page?.page) {
      queryParam += `page=${page?.page}&`;
    }
    if (page?.search_term !== undefined && page?.search_term !== null) {
      queryParam += `search_term=${page?.search_term}&`;
    }
    if (page?.limit !== undefined && page?.limit !== null) {
      queryParam += `limit=${page?.limit}&`;
    }
    if (page?.from_date !== undefined && page?.from_date !== null) {
      queryParam += `startDate=${page?.from_date}&`;
    }
    if (page?.to_date !== undefined && page?.to_date !== null) {
      queryParam += `endDate=${page?.to_date}&`;
    }
    if (page?.manufacturer !== undefined && page?.manufacturer !== null) {
      queryParam += `manufacturer=${page?.manufacturer}&`;
    }
    if (page?.manufacturer_type !== undefined && page?.manufacturer_type !== null) {
      queryParam += `type=${page?.manufacturer_type}&`;
    }
    if (page?.variant_name !== undefined && page?.variant_name !== null) {
      queryParam += `variant_name=${page?.variant_name}&`;
    }
    if (page?.model_name !== undefined && page?.model_name !== null) {
      queryParam += `model_name=${page?.model_name}&`;
    }
    if (page?.usage !== undefined && page?.usage !== null) {
      queryParam += `usages=${page?.usage}&`;
    }
    if (page?.i_am !== undefined && page?.i_am !== null) {
      queryParam += `i_am=${page?.i_am}`;
    }
   
    return axios.get(`${RequestConstant.REQUEST_VEHICLE_API}?${queryParam}`);
  }


  RequestVehicleApi.rejectRequestApi = (id) => {
   
    return axios.post(RequestConstant.REQUEST_REJECT_API,{
      vehicle_id:id
    });
  }
  RequestVehicleApi.approveRequestApi = (id) => {
   
    return axios.post(RequestConstant.REQUEST_APPROVE_API,{
      vehicle_id:id
    });
  }

  RequestVehicleApi.approveUpdateRequestApi = ({id,model,variant}) => {
   
    return axios.put(RequestConstant.REQUEST_UPDATE_API,{
      vehicle_id:id,
      model_id:model,
      variant_id:variant
    });
  }

export { RequestVehicleApi };